import { Component, Input } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { CheckboxInput } from "common/form/input/types/checkbox-input";
import { Button } from "common/data/data-view.component";
import { MaintenanceService } from "common/maintenance/maintenance.service";
import MaintenancePushNotification = stages.core.maintenance.MaintenancePushNotification;

export interface Result {
	remindMe: boolean;
}

@Component({
	selector: "stages-confirm-maintenance",
	templateUrl: "./confirm-maintenance.component.html",
})
export class ConfirmMaintenanceComponent {
	form = new UntypedFormGroup({});

	@Input()
	titleKey!: string;

	@Input()
	messageKey!: string;

	@Input()
	maintenanceInfo!: MaintenancePushNotification;

	doNotShowAgainInput: CheckboxInput;

	buttons: Button[] = [];

	constructor(
		private dialog: DialogAdapter,
		private maintenanceService: MaintenanceService,
		formBuilder: UntypedFormBuilder,
	) {
		this.doNotShowAgainInput = new CheckboxInput({
			key: "doNotShowAgain",
			required: false,
			translateKey: "administration.maintenance.pushNotification.doNotShowAgain",
			value: false,
		});

		this.form.addControl(
			this.doNotShowAgainInput.key,
			formBuilder.control(this.doNotShowAgainInput.value, this.doNotShowAgainInput.validators),
		);

		this.buttons = [
			{
				class: "button sm",
				translate: "administration.maintenance.pushNotification.confirm",
				click: () => {
					this.confirm();
				},
				visible: () => true,
				disabled: () => {
					return false;
				},
			},
		];
	}

	confirm(): void {
		this.dialog.close({ action: "confirm", doNotShowAgain: this.form.controls.doNotShowAgain.value });
	}

	formatDate(date: string | null): string {
		return this.maintenanceService.formatDate(date);
	}
}
